import React from 'react';
import {
    Grid,
    Typography,
} from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import searchImage from '../shared/assets/search.svg';
import { getImageUrl } from '../shared/js/imageUtilities';

const useStyles = makeStyles(() => ({
    root: {
        margin: '98px 0 150px 0',
    },
}));

function Error({ className }: { className?: string; }) {
    const classes = useStyles();

    return (
        <Grid
            alignContent="center"
            alignItems="center"
            className={ClassNames(classes.root, { [className]: !!className })}
            direction="column"
            justifyContent="center"
            spacing={2}
        >
            <Grid.Column>
                <img
                    alt="Search"
                    src={getImageUrl(searchImage)}
                />
            </Grid.Column>
            <Grid.Column>
                <Typography variant="h3">
                    We&rsquo;re Sorry
                </Typography>
            </Grid.Column>
            <Grid.Column>
                <Typography variant="body1">
                    {/* eslint-disable-next-line max-len */}
                    An unexpected system error occurred when we tried to fetch your giving history. Please try again later.
                </Typography>
            </Grid.Column>
        </Grid>
    );
}

export default Error;
